module.exports = __webpack_public_path__ + "images/花筑奢pr长图_07.jpg?v=6d6aa8c3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu2/花筑奢pr长图_07.jpg
 ** module id = 43
 ** module chunks = 1 2
 **/